import { Component, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import i18nDe from "../assets/i18n/de.json";
import i18nEn from "../assets/i18n/en.json";
import { TosModalOpenerComponent } from "./@shared/tos-modal/tos-modal-opener.component";
import { LayoutComponent } from "./layout/layout.component";

@Component({
  selector: "app-root",
  imports: [LayoutComponent, TosModalOpenerComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  private readonly translateService = inject(TranslateService);

  constructor() {
    this.translateService.setTranslation("de", i18nDe);
    this.translateService.setTranslation("en", i18nEn);
  }

}
